import LogoIcon from "./assets/images/logo.png";
import "./App.css";
const HomePage = () => {
  return (
    <div className="home-page">
    <img src={LogoIcon} className="home-logo" alt="Logo" />
    <div className="home-card">
        <h1 style={{ fontSize: 54, marginTop: 0 }}>
            Welcome to our website!
        </h1>
        <ul>
            <li>
                At Nexgen Technology, we've been dedicated to
                delivering top-notch mobile applications since our
                establishment in 2016.
            </li>
            <li>
                As a leader in the mobile app industry, Nexgen
                Technology is committed to innovation and
                excellence.
            </li>
            <li>
                Founded in 2016, Nexgen Technology has grown into a
                reputable name known for crafting solutions that
                cater directly to the needs of our users.
            </li>
            <li>
                Our mission is simple: to provide cutting-edge
                mobile solutions that address real-world
                challenges.
            </li>
            <li>
                Whether you're looking for productivity tools,
                entertainment apps, or anything in between, Nexgen
                Technology has you covered.
            </li>
            <li>
                Our team of talented developers works tirelessly
                to bring your ideas to life, ensuring that every
                app we create is crafted with precision and care.
            </li>
        </ul>
        <p>
            Thank you for visiting Nexgen Technology. We look forward
            to serving you and providing you with the best mobile
            solutions.
        </p>
    </div>
</div>
  )
}

export default HomePage
